import {
  Alert,
  Button,
  ComboboxItem,
  Divider,
  Flex,
  NumberInput,
  Text,
  TextInput,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import {
  IconCalendar,
  IconCheck,
  IconClock,
  IconInfoCircle,
} from "@tabler/icons-react";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import {
  repositoryDelivery,
  repositoryPos,
} from "../../../_base/_const/_constVar";
import { MessageResponse } from "../../../model/MessageResponse";
import { normalizeZnsPhoneNumber } from "../../../service/znsService";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { modals } from "@mantine/modals";
import { useDisclosure } from "@mantine/hooks";
import { getValueById } from "../../../_base/helper/FunctionHelper";

// giờ hợp lệ dạng 24h: 00:00 -> 23:59
const TIME_24H = /^([01]\d|2[0-3]):[0-5]\d$/;

const ExtendDeliveryTime = ({
  data,
  onSuccess,
}: {
  data: any;
  onSuccess: any;
}) => {
  const [visible, { toggle, open, close }] = useDisclosure(false);

  const [appointmentTime] = useState<Date | null>(
    data?.deliveryAppointmentTime && data?.deliveryAppointmentTime?.length > 0
      ? new Date(data?.deliveryAppointmentTime)
      : null,
  );
  // thời gian đã gia hạn của lần gia hạn trước đó (nếu có)
  const [previousExtendTime] = useState<Date | null>(
    data?.extendToDate && String(data?.extendToDate)?.length > 0
      ? new Date(data?.extendToDate)
      : null,
  );

  const [extendTime, setExtendTime] = useState<Date | null>(appointmentTime);
  const [extendDays, setExtendDays] = useState<number | string>(0);
  // giờ gia hạn (HH:mm), mặc định lấy giờ hẹn giao
  const [timeValue, setTimeValue] = useState<string>(
    appointmentTime ? dayjs(appointmentTime).format("HH:mm") : "",
  );

  const [dataBranch, setDataBranch] = useState<ComboboxItem[]>([]);

  // gắn giờ:phút (HH:mm) vào ngày
  const withTime = (date: Date, time: string) => {
    const [hour, minute] = time.split(":").map(Number);
    return dayjs(date)
      .hour(hour || 0)
      .minute(minute || 0)
      .second(0)
      .millisecond(0)
      .toDate();
  };

  // nhập số ngày -> ngày gia hạn = ngày hẹn giao + số ngày, giờ lấy theo ô giờ
  const handleChangeDays = (value: number | string) => {
    setExtendDays(value);
    const days = Number(value);
    if (!appointmentTime || value === "" || Number.isNaN(days)) return;
    setExtendTime(
      withTime(dayjs(appointmentTime).add(days, "day").toDate(), timeValue),
    );
  };

  const isTimeValid = TIME_24H.test(timeValue);

  // chỉ nhận số, tự chèn dấu ":" -> gõ 1730 thành 17:30
  const handleChangeTime = (event: React.ChangeEvent<HTMLInputElement>) => {
    const digits = event.currentTarget.value.replace(/\D/g, "").slice(0, 4);
    const value =
      digits.length > 2 ? `${digits.slice(0, 2)}:${digits.slice(2)}` : digits;
    setTimeValue(value);
    if (TIME_24H.test(value) && extendTime)
      setExtendTime(withTime(extendTime, value));
  };

  // đổi ngày gia hạn -> số ngày = ngày gia hạn - ngày hẹn giao
  const handleChangeDate = (value: Date | null) => {
    setExtendTime(value ? withTime(value, timeValue) : null);
    if (!value || !appointmentTime) {
      setExtendDays(0);
      return;
    }
    setExtendDays(
      dayjs(value)
        .startOf("day")
        .diff(dayjs(appointmentTime).startOf("day"), "day"),
    );
  };

  const getDataBranchSelect = async () => {
    const res = await repositoryDelivery.get<MessageResponse<any>>(
      "/api/v1/TblDmMasterOrg/get-all",
    );

    if (res && res.success) {
      const result = res.data
        ?.filter((i: any) => i.name && i.id)
        ?.map((i: any) => ({
          id: String(i.id),
          name: String(i.name),
          companyCode: String(i.companyCode),
        }));

      setDataBranch(result);
    }
  };

  const handleSendZns = async () => {
    open();
    try {
      const res = await repositoryPos.post<
        MessageResponse<any> & { status?: string | number | null }
      >("/api/v1/Zns/send", {
        from: "2761260980408892837",
        to: normalizeZnsPhoneNumber(data?.telephoneNumber),
        template_id: "420831",
        template_data: {
          customer_name: data?.customerName,
          ngay_du_kien_nhan_hang: dayjs(extendTime).format("DD/MM/YYYY"),
          ma_don_hang: data?.sourceCode,
          so_dien_thoai: data?.telephoneNumber,
          ma_don: data?.sourceCode,
        },
        client_req_id: String(data?.sourceCode) + `${Date.now()}`,
      });

      if (res && String(res.status) === "1") {
        NotificationExtension.Success(
          "Gia hạn thời gian giao hàng thành công !",
        );
        setTimeout(() => {
          modals.closeAll();
          onSuccess();
        }, 1000);
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  const handleExtendDelivery = async () => {
    open();
    try {
      const res = await repositoryDelivery.post<MessageResponse<any>>(
        "/api/v1/TblDelivery/update-extend",
        {
          ids: [data?.id],
          // cộng 7 tiếng để giờ:phút gửi lên (UTC) đúng bằng giờ:phút đã chọn
          extendToDate: dayjs(extendTime || "")
            .second(0)
            .millisecond(0)
            .add(7, "hour")
            .toDate(),
        },
      );

      if (res && res.success) {
        // if (
        //   (!data.extendToDate ||
        //     new Date(extendTime || "") > new Date(data.extendToDate)) &&
        //   getValueById(String(data?.branchId), dataBranch, "companyCode") !==
        //     "DVT"
        // ) {
        //   handleSendZns();
        // } else {
        NotificationExtension.Success(
          "Gia hạn thời gian giao hàng thành công !",
        );
        setTimeout(() => {
          modals.closeAll();
          onSuccess();
        }, 1000);
        // }
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  useEffect(() => {
    getDataBranchSelect();
  }, []);

  return (
    <Flex direction={"column"} justify={"center"} gap={"xs"} mt={10} w={350}>
      {previousExtendTime && (
        <Alert
          variant="light"
          color="orange"
          p={"xs"}
          icon={<IconInfoCircle size={20} />}
          styles={{
            wrapper: { alignItems: "center" },
            icon: { marginTop: 0, marginInlineEnd: 10 },
          }}
        >
          <Text size="sm">
            Đơn đã được gia hạn đến ngày{" "}
            <Text span fw={700} inherit>
              {dayjs(previousExtendTime).format("DD/MM/YYYY HH:mm")}
            </Text>
          </Text>
        </Alert>
      )}
      <NumberInput
        label="Số ngày gia hạn"
        placeholder="Nhập số ngày gia hạn"
        min={0}
        allowDecimal={false}
        allowNegative={false}
        clampBehavior="strict"
        hideControls
        suffix=" ngày"
        value={extendDays}
        onChange={handleChangeDays}
      />
      <Divider labelPosition="center" label="hoặc" mt={7.5} />
      <Flex gap={"xs"}>
        <DatePickerInput
          flex={1}
          label="Ngày gia hạn thêm"
          placeholder="Chọn ngày gia hạn thêm"
          locale="vi"
          valueFormat="DD/MM/YYYY"
          value={extendTime}
          minDate={
            appointmentTime && appointmentTime > new Date()
              ? appointmentTime
              : new Date()
          }
          onChange={handleChangeDate}
          leftSection={<IconCalendar color="#15aabf" />}
        />
        <TextInput
          w={120}
          label="Giờ gia hạn"
          placeholder="HH:mm"
          inputMode="numeric"
          value={timeValue}
          onChange={handleChangeTime}
          error={timeValue.length === 5 && !isTimeValid}
          leftSection={<IconClock color="#15aabf" />}
        />
      </Flex>
      <Button
        leftSection={<IconCheck size={16} />}
        loading={visible}
        // cho lưu khi thời gian gia hạn sau thời gian hẹn giao (kể cả cùng ngày, khác giờ)
        disabled={
          !appointmentTime ||
          !extendTime ||
          !isTimeValid ||
          !dayjs(extendTime).isAfter(appointmentTime) ||
          visible
        }
        onClick={() => handleExtendDelivery()}
      >
        Lưu
      </Button>
    </Flex>
  );
};

export default ExtendDeliveryTime;
